<template>
  <ul class="personnel-inner" v-iscroll>
    <div class="warp-pre">
      <li v-for="(item, index) in listArr" @click="link(false)">
        <a href="#/index/people">
          <div class="pic" style="background-image:url('static/images/ex_pic16.jpg');"></div>
          <span class="name">{{item.name}}</span>
          <br>
          <span class="number">{{item.number}}</span>
        </a> 
      </li>
    </div>
  </ul>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {},
    props: [
      'listArr'
    ],
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
        'AgetBack'
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      link (swit) {
        this.AgetBack(swit)
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .personnel-inner {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
    list-style: none;
    cursor: pointer;
    .warp-pre {
      width: 100%;
      height: auto;
    }
    h3 {
      color: $white;
    }
    li {
      position: relative;
      width: 100%;
      height: auto;
      a {
        position: relative;
        width: 100%;
        height: auto;
        padding-top: 10px;
        padding-left: 100px;
        color: $white;
        display: block;
      }
      .pic {
        position: absolute;
        left: 10px;
        top: 10px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-size: cover;
      }
      span {
        display: inline-block;
        padding-bottom: 10px;
        font-size: 18px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// personnel-list.vue?2394c198